<script lang="ts" setup>
import { ParagraphEventRegistration } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphEventRegistration
}>()

const title = ref(props.entity.fieldTitle ?? '')
const description = ref(props.entity.fieldDescription?.processed ?? '')
</script>

<template>
  <SectionSpecial :title="title" :sub-title="description">
    <EventRegistrationForm :entity="entity" />
  </SectionSpecial>
</template>
